<template>
  <div class="companyBox">
    <Form ref="searchForm" :label-width="90" :model="formCustom" inline>
      <Form-item label="员工编号：" prop="groupName">
        <Input
          v-model="formCustom.groupName"
          :maxlength="50"
          clearable
          style="width: 200px"
        ></Input>
      </Form-item>
      <Form-item label="姓名：" prop="companyName">
        <Input
          v-model="formCustom.companyName"
          :maxlength="50"
          clearable
          style="width: 200px"
        ></Input>
      </Form-item>
      <Form-item label="员工类型：" prop="deptName">
        <Select v-model="formCustom.status" clearable filterable style="width: 200px">
          <Option value="1">全职</Option>
          <Option value="2">兼职</Option>
        </Select>
      </Form-item>
      <br>

      <Form-item label="员工状态：" prop="status">
        <Select v-model="formCustom.status" clearable filterable style="width: 200px">
          <Option value="1">在职</Option>
          <Option value="2">待入职</Option>
          <Option value="3">离职</Option>
        </Select>
      </Form-item>
      <Form-item label="家属姓名：" prop="evaluationCategory">
        <Input
          v-model="formCustom.evaluationCategory"
          :maxlength="50"
          clearable
          style="width: 200px"
        ></Input>
      </Form-item>
      <Form-item label="护照号：" prop="evaluationCategory">
        <Input
          v-model="formCustom.evaluationCategory"
          :maxlength="50"
          clearable
          style="width: 200px"
        ></Input>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')"
        >重置
        </Button
        >
      </Form-item>
    </Form>
    <div style="margin-bottom: 20px">
      <Button type="primary" @click="addEvaluation">新建</Button>
      <Button style="margin-left: 10px;" type="primary" @click="addEvaluation">导出员工</Button>
      <Button style="margin-left: 10px;" type="primary" @click="addEvaluation">下载导入模板</Button>
      <Button style="margin-left: 10px;" type="primary" @click="addEvaluation">批量导入职工</Button>
      <Button style="margin-left: 10px;" type="primary" @click="addEvaluation">导出证明信息</Button>
      <Button style="margin-left: 10px;" type="primary" @click="addEvaluation">导出历史变更记录</Button>
    </div>
    <div>
      <Table
        :columns="companyColumns"
        :data="companyTableData"
        :loading="loading"
        aria-describedby=""
        aria-hidden="true"
        border
        @on-selection-change="selectionChange"
      >
        <template slot="action" slot-scope="{ row }">
          <Button
            size="small"
            type="text"
            @click="deleteEvaluation(row)"
          >查看
          </Button>
          <Button
            size="small"
            type="text"
            @click="deleteEvaluation(row)"
          >编辑
          </Button>
          <Button
            size="small"
            type="text"
            @click="deleteEvaluation(row)"
          >离职
          </Button>
          <Button
            size="small"
            type="text"
            @click="deleteEvaluation(row)"
          >入职
          </Button>
        </template>
        <template slot="status" slot-scope="{ row }">
          <p v-if="roleType == 4 || roleType == 3">{{
              row.status == 0 ? '草稿' : row.status == 1 ? '待审核' : row.status == 2 ? '未完成' : '已完成'
            }}</p>
          <p v-else>{{
              row.status == 0 ? '草稿' : row.status == 1 ? '未完成' : row.status == 2 ? '未完成' : '已完成'
            }}</p>
        </template>
      </Table>
      <Page
        ref="pages"
        :current="page"
        :total="total"
        class="page_position"
        show-elevator
        show-sizer
        show-total
        @on-change="setCurrent"
        @on-page-size-change="setPage"
      ></Page>
    </div>
    <addforeignEmployess
      :isupload="isupload"
      :model="addRow"
      :select="select"
      :visible="visibleAdd"
      @cancel="handleCancelAdd"
      @successadd="successadd"
    />
    <addfamily
      :isupload="isuploadFalily"
      :model="addrowFalily"
      :select="selectFalily"
      :visible="visibleFalily"
      @cancel="handleCancelFalily"
      @successadd="successFalily"
    />
    <exportfile
      :isupload="isuploadExportfile"
      :model="addrowExportfile"
      :select="selectExportfile"
      :visible="visibleExportfile"
      @cancel="handleCancelExportfile"
      @successadd="successExportfile"
    />
    <export-record
      :isupload="isuploadExportRecord"
      :model="addrowExportRecord"
      :select="selectExportRecord"
      :visible="visibleExportRecord"
      @cancel="handleCancelExportRecord"
      @successadd="successExportRecord"
    />
  </div>
</template>

<script>
import permissionList from "@/libs/handlePermission.ts";
import addforeignEmployess from "./addforeignEmployess.vue"
import addfamily from "./addfamily.vue"
import exportfile from "./exportfile.vue"
import exportRecord from "./exportRecord.vue"
import {employeePage} from "@/api/employee";

export default {
  name: "company",
  data() {
    return {
      isuploadFalily: false,
      addrowFalily: [],
      selectFalily: false,
      visibleFalily: false,
      isuploadExportRecord: false,
      addrowExportRecord: [],
      selectExportRecord: false,
      visibleExportRecord: false,
      isuploadExportfile: false,
      addrowExportfile: [],
      selectExportfile: false,
      visibleExportfile: false,
      absenteeismUrl: '',
      dialogFormVisible: false,
      visibleAdd: false,
      select: false,
      visibleFillIn: false,
      addRow: {},
      dialogVisible: false,
      dialogTableVisible: false,
      dialogWorkerVisible: false,
      tableData: [],
      total: 0,
      page: 1,
      dialogtotal: 0,
      dialogpage: 1,
      dialogloading: false,
      dialogWorkerloading: false,
      tableWorkerData: [],
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      btnList: [],
      companyIds: "",
      formCustomTable: {},
      formCustom: {},
      asyncRoute: {
        pass: '1',
        checkIdea: ''
      },
      columnsWorker: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "姓名", key: "employeeRealName", align: "center"},
        {title: "职位", key: "employeePositionName", align: "center"},
        {title: "考评项", key: "evaluationItem", align: "center"},
        {title: "附件", slot: "leaveUrl", key: "leaveUrl", align: "center"},
        {title: "考评角色", key: "evaluationRole", align: "center"},
        {title: "状态", key: "auditStatus", align: "center", slot: "auditStatus"},
        {title: "审核意见", key: "auditIdea", align: "center"},
        {title: "操作", slot: "action", align: "center", fixed: "right"},
      ],
      companyColumns: [
        {type: "index", title: "序号", align: "center"},
        {title: "员工编号", key: "groupName", align: "center"},
        {title: "姓名", key: "companyName", align: "center"},
        {title: "国籍", key: "deptName", align: "center"},
        {title: "性别", key: "evaluationCategory", align: "center"},
        {title: "手机号码", key: "evaluationRole", align: "center"},
        {title: "出生年月日", key: "createTime", align: "center"},
        {title: "护照号码", key: "publishTime", align: "center"},
        {title: "员工类型", key: "publishTime", align: "center"},
        {title: "家属姓名", key: "publishTime", align: "center"},
        {title: "员工状态", key: "status", align: "center", slot: "status"},
        {title: "操作", slot: "action", align: "center", fixed: "right"},
      ],
      columns: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属集团", key: "groupName", align: "center"},
        {title: "所属公司", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "姓名", key: "employeeRealName", align: "center"},
        {title: "职位", key: "employeePositionName", align: "center"},
        {title: "状态", key: "status", align: "center", slot: "status"},
        {title: "操作", slot: "action", align: "center", fixed: "right"},
      ],
      companyTableData: [], // 表格数据
      row: {},
      areaData: [],
      countyCode: "",
      industryTypeList: [], // 行业类型
      companyScaleList: [], // 企业规模
      addDialogVisible: false,
      editDialogVisible: false,
      dialogAuditVisible: false,
      roleType: '',
      companyAttendanceIds: '',
      val: new Date(),
      daylist: [],
      holidaylist: [],
      cutoffTime: '',
      isupload: false,
      workerRow: {},
      employeerow: {},
      isuploadWorker: false,

      attendanceDate: '',
      BaseUrl: process.env.VUE_APP_BASE_URL,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("getToken"),
      },
      upAction: this.$getImg + 'api/auth/file', // 上传图片网址
      getToken: {Authorization: 'Bearer ' + localStorage.getToken},
    }
  },
  components: {
    addforeignEmployess,
    addfamily,
    exportfile,
    exportRecord
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem("routerList"))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    this.init()
    let token = localStorage.getItem('getToken')
    let userString = decodeURIComponent((window.atob(token.split('.')[1].replace(/-/g, "+").replace(/_/g, "/"))))
    let user = JSON.parse(userString);
    this.roleType = user.roleType;
    console.log(this.roleType)
  },
  methods: {
    downloadFile(row) {
      window.open(row.templatePath)
    },
    auditclick() {
      if (!this.asyncRoute.checkIdea && this.asyncRoute.pass == '2') {
        this.$message.error('请填写审核意见')
        return
      }
      let pass = true
      if (this.asyncRoute.pass == '2') {
        pass = false
      }
      companyEvaluationEmployeeRecordAudit({
        subjectId: this.workerRow.companyEvaluationEmployeeRecordId,
        pass: pass,
        checkIdea: this.asyncRoute.checkIdea,
      }).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.msg)
          this.dialogAuditVisible = false
          this.handleSearchWorker()
          this.handleSearchEmployee()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    leaveShow(row) {
      console.log(row)
      if (row.evaluationItem == '员工考评表') {
        window.open(row.employeeEvaluationUrl, '_blank')
      }
      if (row.evaluationItem == '员工互评表') {
        window.open(row.employeeMutualEvaluationUrl, '_blank')
      }
      if (row.evaluationItem == '用人部门打分表') {
        window.open(row.employmentEvaluationUrl, '_blank')
      }
      if (row.evaluationItem == '各部门打分表') {
        window.open(row.departmentEvaluationUrl, '_blank')
      }
    },
    submit() {
      if (!this.absenteeismUrl) {
        this.$message.error('请先上传')
        return
      }
      let params = {
        companyEvaluationEmployeeRecordId: this.workerRow.companyEvaluationEmployeeRecordId,
      }
      if (this.workerRow.evaluationItem == '员工考评表') {
        params.employeeEvaluationUrl = this.absenteeismUrl
      }
      if (this.workerRow.evaluationItem == '员工互评表') {
        params.employeeMutualEvaluationUrl = this.absenteeismUrl
      }
      if (this.workerRow.evaluationItem == '用人部门打分表') {
        params.employmentEvaluationUrl = this.absenteeismUrl
      }
      if (this.workerRow.evaluationItem == '各部门打分表') {
        params.departmentEvaluationUrl = this.absenteeismUrl
      }
      companyEvaluationEmployeeRecordPut(params).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.msg)
          this.dialogFormVisible = false
          this.handleSearchWorker()
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch(error => {
        this.$message.error(error.response.data.msg)
      })
    },
    uploadFile(row) {
      this.workerRow = row
      if (this.$refs.upload != undefined) {
        this.$refs["upload"].clearFiles()
      }
      this.dialogFormVisible = true
      this.absenteeismUrl = ''
    },
    handleSuccess(response) {
      this.absenteeismUrl = this.$getImgFile + response.data
    },
    handleError(error, file) {
      this.$message.error(file.msg)
    },
    // 超出限制大小
    handleMaxSize() {
      this.$message.error('所传图片不能超过2M,请重新选择')
    },
    // 验证失败钩子
    handleFormatError() {
      this.$message.error('请上传正确的图片格式，仅支持jpg，jpeg，png三种格式')
    },
    cancelAudit() {
      this.dialogAuditVisible = false
      // this.asyncRoute.checkIdea = ''
    },
    auditWorker(row) {
      this.$confirmss('确认提交审核？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        companyEvaluationEmployeeRecordSubmitAudit({companyEvaluationEmployeeRecordId: row.companyEvaluationEmployeeRecordId}).then((res) => {
          if (res.data.success === false) {
            this.$message.warning(res.data.msg)
          } else {
            this.$message.success(res.data.msg)
            this.handleSearchWorker()
          }
          this.init()
        }).catch((error) => {
          this.$message.error(error.response.data.msg)
        })
      }).catch(() => {
        this.$message.info('已取消')
      })
    },
    successadd() {
      this.init()
      this.visibleAdd = false
    },
    addEvaluation() {
      this.addRow = {}
      this.isupload = false
      this.select = false
      this.visibleAdd = true
    },
    save() {
      this.visibleFillIn = false
      this.handleSearchWorker()
    },
    handleCancelAdd() {
      this.visibleAdd = false
    },
    gofillIn(row) {
      this.row = row
      this.visibleFillIn = true
    },
    handleCancelFillIn() {
      this.visibleFillIn = false
    },
    // 初始化
    init() {
      this.loading = true
      employeePage({
        current: 1,
        size: 10
      }).then((res) => {
        this.changeData(res);
      });
    },
    selectionChange(rows) {
      if (rows && rows.length > 0) {
        let ids = [];
        console.log(rows)
        rows.forEach((row) => {
          ids.push(row.companyAttendanceId);
        });
        this.companyAttendanceIds = ids.join(",");
      } else {
        this.companyAttendanceIds = ''
      }
    },
    check(row) {//查看详情
      this.addRow = row
      this.isupload = true
      this.visibleAdd = true
      this.select = true
    },
    checks(row) {//编辑详情
      this.addRow = row
      this.isupload = true
      this.select = false
      this.visibleAdd = true
    },
    goEmployee(row) {//查看职工
      this.row = row
      this.dialogTableVisible = true
      pageCompanyEvaluationEmployee({
        companyEvaluationId: row.companyEvaluationId,
        current: 1,
        size: 10
      }).then((res) => {
        this.dialogchangeData(res);
      });
    },
    checkWorker(row) {//查看职工详情
      this.employeerow = row
      this.dialogWorkerVisible = true
      companyEvaluationEmployeeRecordPage({
        companyEvaluationEmployeeId: row.companyEvaluationEmployeeId,
        current: 1,
        size: 10
      }).then((res) => {
        this.dialogWorkerchangeData(res);
      });
    },

    checksWorker(row) {//查看详情
      this.workerRow = row
      this.visibleFillIn = true
    },
    deleteEvaluation(row) {
      this.$Modal.confirm({
        title: '确认删除？',
        onOk: () => {
          companyEvaluationDelete({companyEvaluationId: row.companyEvaluationId}).then((res) => {
            if (res.data.success === false) {
              this.$message.warning(res.data.msg)
            } else {
              this.$message.success(res.data.msg)
            }
            this.init()
          }).catch((error) => {
            this.$message.error(error.response.data.msg)
          })
        },
        onCancel: () => {
          this.$message.info('已取消删除')
        }
      })
    },
    // 查询
    handleSearchWorker() {
      companyEvaluationEmployeeRecordPage({
        companyEvaluationEmployeeId: this.workerRow.companyEvaluationEmployeeId,
        current: 1,
        size: 10,
      }).then((res) => {
        this.dialogWorkerchangeData(res);
      });
    },
    handleSearchEmployee() {
      pageCompanyEvaluationEmployee({
        current: 1,
        size: 10,
        companyEvaluationId: this.row.companyEvaluationId,
        companyName: this.formCustomTable.companyName,
        deptName: this.formCustomTable.deptName,
        employeeRealName: this.formCustomTable.employeeRealName,
        status: this.formCustomTable.status
      }).then((res) => {
        this.dialogchangeData(res);
      });
    },
    handleSearch() {
      this.loading = true
      employeePage({
        current: 1,
        size: this.pageSize,
        groupName: this.formCustom.groupName,
        companyName: this.formCustom.companyName,
        deptName: this.formCustom.deptName,
        evaluationCategory: this.formCustom.evaluationCategory,
        status: this.formCustom.status
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      });
    },

    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total;
      this.size = res.data.data.size;
      this.companyTableData = res.data.data.records;
      this.loading = false;
    },
    dialogchangeData(res) {
      this.dialogtotal = res.data.data.total;
      this.dialogsize = res.data.data.size;
      this.tableData = res.data.data.records;
      this.dialogloading = false;
    },
    dialogWorkerchangeData(res) {
      this.dialogWorkertotal = res.data.data.total;
      this.dialogWorkersize = res.data.data.size;
      this.tableWorkerData = res.data.data.records;
      this.dialogWorkerloading = false;
    },
    // 重置
    handleReset(name) {
      this.$refs[name].resetFields();
      // 重置查询条件会再次查询
      this.handleSearch();
    },
    // 重置
    handleResetEmployee(name) {
      this.$refs[name].resetFields();
      // 重置查询条件会再次查询
      this.handleSearchEmployee();
    },
    // 改变页码
    dialogsetCurrent(val) {
      this.dialogloading = true;
      this.dialogpage = val;
      pageCompanyEvaluationEmployee({
        current: val,
        size: this.pageSize,
        companyEvaluationId: this.row.companyEvaluationId,
        companyName: this.formCustomTable.companyName,
        deptName: this.formCustomTable.deptName,
        employeeRealName: this.formCustomTable.employeeRealName,
        status: this.formCustomTable.status
      }).then((res) => {
        this.dialogchangeData(res);
      });
    },
    // 改变每页条数
    dialogsetPage(val) {
      this.dialogloading = true;
      this.pageSize = val;
      pageCompanyEvaluationEmployee({
        current: 1,
        size: this.pageSize,
        companyEvaluationId: this.row.companyEvaluationId,
        companyName: this.formCustomTable.companyName,
        deptName: this.formCustomTable.deptName,
        employeeRealName: this.formCustomTable.employeeRealName,
        status: this.formCustomTable.status
      }).then((res) => {
        this.dialogchangeData(res);
        this.$refs["dialogpages"].currentPage = 1; // 分页变成第一页
      });
    },
    setCurrent(val) {
      this.loading = true
      let data = {
        ...this.formCustom,
      };
      this.loading = true;
      this.page = val;
      employeePage({
        current: val,
        size: this.pageSize,
        ...data,
      }).then((res) => {
        this.changeData(res);
      });
    },
    // 改变每页条数
    setPage(val) {
      this.loading = true
      let data = {
        ...this.formCustom,
      };
      this.loading = true;
      this.pageSize = val;
      employeePage({
        current: 1,
        size: this.pageSize,
        ...data,
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      });
    },
    audit(row) {
      this.workerRow = row
      this.dialogAuditVisible = true
      this.asyncRoute.checkIdea = ''
      this.asyncRoute.pass = '1'
    },
    publish(row) {
      companyEvaluationPublish({companyEvaluationId: row.companyEvaluationId}).then(res => {
        if (res.data.success) {
          this.$message.success('发布成功')
          this.init()
        }
      }).catch(error => {
        this.$message.error(error.response.data.msg)
      })
    }
  }
}
</script>
<style lang="less">
.red {
  background-color: rgba(243, 12, 1, 0.48);
  color: rgb(0, 0, 0);
  padding: 8px;
}

.green {
  background-color: rgba(66, 165, 111, 0.5);
  padding: 8px;
  color: rgba(55, 55, 55);
}

.el-calendar-table td .el-calendar-day {
  padding: 0;
}

.el-calendar__header {
  display: none
}
</style>
